import React from "react";
import { withRouter } from "react-router-dom";
import axios from "axios";
import { Row, Col, Form} from "antd";
import AuthenticatedComponent from "../../AuthenticatedComponent";
import Template from "../../interfaz/Template.js";
import * as etiquetas from '../../../ApplicationResources';
import {  connect } from "react-redux";
import '../../../css/modelStyle.css';
import HeaderModule from "../../interfaz/Elements/HeaderModule";
import Menu from "../../interfaz/Elements/Menu";
import { createStructuredSelector } from "reselect";
import { selectDistrito, selectEstado, selectParticipacion, selectProceso } from "../../../redux/menu/menu-selectors";
import { selectCurrentUser } from "../../../redux/user/user-selectors";
import ModalMensajes from "../../interfaz/ModalMensajes";
import JuntaEjecutivaModifica from "./JuntaEjecutivaModifica";
import JuntaEjecutivaConsulta from "./JuntaEjecutivaConsulta";

class JuntaEjecutiva extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
        municipios : undefined,
        informacionJunta : undefined,
        modificarDatos : false,
        cargando : false,
        // Variables necesarias para el componente ModalMensajes.jsx
        modalTipoMensaje : "",
        modalMensaje : "",
        modalAbrir : false
    };
  }

  componentWillMount() {
    const {datosUsuario} = this.props;
    const rolUsuario = datosUsuario ? datosUsuario.rolUsuario : "";
    // Indica si el rol del usuario tiene permiso de administrador o no (true / false)
    const permisoAdministrador = etiquetas.rolesAdmin.includes(rolUsuario);

    if(!permisoAdministrador)
      this.props.history.push('/menuJDE');

    this.validarCombosProcesos();
  }

  inicializarEstados = () => {
    this.setState({
      modificarDatos : false
    });
  }

  componentDidUpdate(prevProps) {
    // Comparamos si el usuario ha seleccionado otro estado, proceso, distrito para volver a cargar la gráfica y actividades
    if(this.props.proceso !== prevProps.proceso
      || this.props.selectEstado !== prevProps.selectEstado
      || this.props.selectDistrito !== prevProps.selectDistrito){
        this.validarCombosProcesos();

        return;
      }
  }

  consultarMunicipios = async () => {
    try {
     const { proceso, selectEstado } = this.props;
     const idCorte = proceso ? proceso.corte : 0;
     const idEstado = selectEstado ? selectEstado.idEstado : 0;

     this.setState({cargando : true});

       const response = await axios.post(process.env.REACT_APP_API_URL + '/centralReclutaSEyCAE/ws/consultarMunicipios'
         ,{         
            idEstado: idEstado,
            idCorte: idCorte
         },{
             headers: {
                 'Accept': 'application/json'
                 ,'Content-Type': 'application/json'
             }
         }
       );
 
       this.setState({cargando : false});
 
       if(response.data) {
         this.setState({ municipios : response.data });console.log("Municipios consultados");
       }
    } catch(error) {
     this.setState({cargando : false});
     this.modalAbrir(etiquetas.CONSTANTE_MODAL_TIPO_MENSAJE_ERROR, "Ocurrió un error al cargar la información. Por favor vuelva a intentarlo más tarde.");
    }
 }

  /**
   * Función que consulta la información de la junta distrital
   */
   consultarInformacionJuntaDistrital = async () => {
     try {
      const { proceso, selectParticipacion } = this.props;
      const idProcesoElectoral = proceso ? proceso.idProcesoElectoral : 0;
      const idDetalleProceso = proceso ? proceso.idDetalleProceso : 0;
      const idParticipacion = selectParticipacion ? selectParticipacion : 0;
      const idCorte = proceso ? proceso.corte : 0;

      this.setState({cargando : true});

        const response = await axios.post(process.env.REACT_APP_API_URL + '/centralReclutaSEyCAE/ws/consultarJuntaDistrital'
          ,{         
              idProcesoElectoral : idProcesoElectoral,
              idDetalleProceso : idDetalleProceso,
              idParticipacion: idParticipacion,
              idCorte: idCorte
          },{
              headers: {
                  'Accept': 'application/json'
                  ,'Content-Type': 'application/json'
              }
          }
        );
  
        this.setState({cargando : false});
  
        if(response.data) {
          this.setState({
            informacionJunta : response.data,
          });
        } else {
          this.setState({
            informacionJunta : undefined
          });
        }
     } catch(error) {
      this.setState({cargando : false});
      this.modalAbrir(etiquetas.CONSTANTE_MODAL_TIPO_MENSAJE_ERROR, "Ocurrió un error al cargar la información. Por favor vuelva a intentarlo más tarde.");
     }
  }

  /**
   * Función que almacena la información de la junta distrital
   */
   guardarInformacionJuntaDistrital = async (calle, numeroExterior, numeroInterior, 
    colonia, codigoPostal, idMunicipio, referencias, tratamiento, nombres, primerApellido,
    segundoApellido, correo, telefono, extension) => {
     try {
      const { proceso, selectParticipacion } = this.props;
      const idProcesoElectoral = proceso ? proceso.idProcesoElectoral : 0;
      const idDetalleProceso = proceso ? proceso.idDetalleProceso : 0;
      const idParticipacion = selectParticipacion ? selectParticipacion : 0;
      const idCorte = proceso ? proceso.corte : 0;

      this.setState({cargando : true});
  
        const response = await axios.post(process.env.REACT_APP_API_URL + '/centralReclutaSEyCAE/ws/guardarDatosJuntaDistrital'
          ,{         
              idProcesoElectoral : idProcesoElectoral,
              idDetalleProceso : idDetalleProceso,
              idParticipacion : idParticipacion,
              calle: calle,
              numeroExterior : numeroExterior,
              numeroInterior : numeroInterior,
              colonia : colonia, 
              codigoPostal : codigoPostal, 
              idMunicipio : idMunicipio,
              referencias : referencias,
              tratamiento : tratamiento,
              nombres : nombres,
              primerApellido : primerApellido,
              segundoApellido : segundoApellido,
              telefono : telefono,
              extension : extension,
              correo : correo,
              idCorte : idCorte
          },{
              headers: {
                  'Accept': 'application/json'
                  ,'Content-Type': 'application/json'
                  ,Authorization: localStorage.getItem("jwt-token")
              }
          }
        );
  
        if(response.data && response.data === true) {
          // Los cambios se almacenaron
          // Inicializamos los estates
          this.inicializarEstados();
          // Consultamos la información de la junta distrital
          this.consultarInformacionJuntaDistrital();
          // Abrimos el modal informativo
          this.modalAbrir(etiquetas.CONSTANTE_MODAL_TIPO_MENSAJE_NOTIFICACION, "Los cambios se han guardado exitosamente.");
        } else {
          this.modalAbrir(etiquetas.CONSTANTE_MODAL_TIPO_MENSAJE_ERROR, "Ocurrió un error al guardar los cambios.");
        }
  
        this.setState({cargando : false});
     } catch(error) {
        this.setState({cargando : false});
        this.modalAbrir(etiquetas.CONSTANTE_MODAL_TIPO_MENSAJE_ERROR, "Ocurrió un error al guardar los cambios.");
     }
  }

  /**
   * Función que valida si el usuario ha seleccionado un proceso electoral y un distrito
   */
  validarCombosProcesos = () => {
    const { proceso, selectDistrito } = this.props;
    const idProcesoElectoral = proceso ? proceso.idProcesoElectoral : 0;
    const idDetalleProceso = proceso ? proceso.idDetalleProceso : 0;
    const idDistrito = selectDistrito ? selectDistrito.idDistrito : 0;

    // Si el usuario no ha seleccionado proceso o distrito, lo redireccionamos al menú principal
    if(idProcesoElectoral === 0 || idDetalleProceso === 0 || idDistrito === 0)
      this.props.history.push('/menuJDE');
    else {
      // Si hay un cambio de distrito, inicializamos los estates
      this.inicializarEstados();
      // Consultamos la información de la junta distrital
      this.consultarInformacionJuntaDistrital();
      // Borramos los municipios consultados previamente
      this.setState({ municipios : undefined});
    }
  }

  onClickBtnModificar = () => {
    this.setState({
      modificarDatos : true
    });
  }

  onClickBtnCancelar = () => {
    this.setState({
      modificarDatos : false
    });
  }

  modalCerrar = () => {
    this.setState({ modalAbrir : false});
  }

  modalAbrir = (tipoMensaje, mensaje) => {
    this.setState({
      modalTipoMensaje : tipoMensaje,
      modalMensaje : mensaje,
      modalAbrir : true
    });
  }

  render() {
    return (
      <AuthenticatedComponent>
        <Template
          contenido={
            <>
              <Menu />
              <div className="contenedor_junta_ejecutiva">
                <Row>
                    <Col sm={24} md={24} lg={24}>
                        <HeaderModule title={etiquetas.ETIQUETA_JUNTA_EJECUTIVA_TITULO_MODULO} redireccionar={'/menuJDE'} />
                    </Col>
                </Row>
                {
                  this.state.modificarDatos ?
                    <JuntaEjecutivaModifica informacionJunta={this.state.informacionJunta} municipios={this.state.municipios} onClickBtnCancelar={this.onClickBtnCancelar} guardarInformacionJuntaDistrital={this.guardarInformacionJuntaDistrital} consultarMunicipios={this.consultarMunicipios} />:
                    <JuntaEjecutivaConsulta informacionJunta={this.state.informacionJunta} onClickBtnModificar={this.onClickBtnModificar} />
                }
              </div>
            </>
          }
          bloqueado={false}
          guia={false}
          cargando={this.state.cargando}
        >
        </Template>
        <ModalMensajes 
          tipoMensaje={this.state.modalTipoMensaje} 
          mensaje={this.state.modalMensaje} 
          abrirModal={this.state.modalAbrir} 
          cerrarModal={this.modalCerrar} />
      </AuthenticatedComponent>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  proceso: selectProceso,
  datosUsuario: selectCurrentUser,
  selectDistrito : selectDistrito,
  selectEstado: selectEstado,
  selectParticipacion : selectParticipacion
});

export default withRouter(connect(mapStateToProps)(JuntaEjecutiva));